var Handlebars = require('/src/melia-widget/node_modules/handlebars/runtime.js');
module.exports = (Handlebars['default'] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    return "onlyOneIcon";
},"3":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "      <span class=\"transport-icon "
    + container.escapeExpression(container.lambda(depth0, depth0))
    + "\"></span>\n"
    + ((stack1 = helpers.unless.call(depth0 != null ? depth0 : (container.nullContext || {}),(data && data.last),{"name":"unless","hash":{},"fn":container.program(4, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "");
},"4":function(container,depth0,helpers,partials,data) {
    return "        <span class=\"transport-icon lmm-label-arrow\"></span>\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, helper, alias1=container.escapeExpression, alias2=depth0 != null ? depth0 : (container.nullContext || {}), alias3=helpers.helperMissing, alias4="function";

  return "<div class='lmm-label label-"
    + alias1(container.lambda(((stack1 = (depth0 != null ? depth0.direction : depth0)) != null ? stack1.arrow : stack1), depth0))
    + " "
    + ((stack1 = helpers["if"].call(alias2,(depth0 != null ? depth0.onlyOneIcon : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "'>\n  <div class=\"lmm-label-steps-icons\">\n"
    + ((stack1 = helpers.each.call(alias2,(depth0 != null ? depth0.travelModeIcons : depth0),{"name":"each","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "  </div>\n  <div class=\"lmm-label-duration\">\n    <span class=\"lmm-label-text\">"
    + alias1(((helper = (helper = helpers.totalTimeFormatedString || (depth0 != null ? depth0.totalTimeFormatedString : depth0)) != null ? helper : alias3),(typeof helper === alias4 ? helper.call(alias2,{"name":"totalTimeFormatedString","hash":{},"data":data}) : helper)))
    + "</span>\n  </div>\n  <div class=\"lmm-label-distance\">\n    <span class=\"lmm-label-text\">"
    + alias1(((helper = (helper = helpers.distance || (depth0 != null ? depth0.distance : depth0)) != null ? helper : alias3),(typeof helper === alias4 ? helper.call(alias2,{"name":"distance","hash":{},"data":data}) : helper)))
    + "</span>\n  </div>\n</div>";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./lmm-widget/src/views/routeLabels/routeLabels.hbs
// module id = 155
// module chunks = 1